import React, { Component } from 'react';
import { Select, Tooltip } from 'antd';
import $ from '../../common/AjaxRequest';

let timeout;
const { Option } = Select;

class SearchInput extends Component {
    state = {
        isClearTimeout: true,
    }

    componentDidMount() {
        const { isEdit, initValue = {} } = this.props;
        this.initValue(initValue, isEdit);
    }

    componentDidUpdate(prevProps) {
        const { initValue = {}, isEdit } = this.props;
        if (JSON.stringify(initValue) !== JSON.stringify(prevProps.initValue)) {
            this.initValue(initValue, isEdit);
        }
    }

    initValue = (initValue, isEdit) => {
        const { key = '', label = '' } = initValue;
        const value = (key && label) ? { key: String(key), label: String(label) } : undefined;
        this.setState({
            value,
            isClearTimeout: !isEdit,
        }, () => {
            isEdit && value && this.handleChange(value);
        });
    }

    fetch = (value) => {
        const { isClearTimeout } = this.state;
        if (timeout && isClearTimeout) {
            clearTimeout(timeout);
            timeout = null;
        }

        timeout = setTimeout(() => {
            const { url, keyword, parseData, params = {} } = this.props;
            const options = {
                url,
                data: {
                    ...params,
                    [keyword]: value,
                },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ isClearTimeout: true }, () => {
                        parseData(res);
                    });
                },
            };
            $.sendRequest(options);
        }, 300);
    }

    handleFocus = () => {
        const { handleFocus, dataSource = [] } = this.props;
        if (dataSource.length) {
            return;
        }
        if (handleFocus) {
            const data = handleFocus();
            data && this.fetch('');
        } else {
            this.fetch('');
        }
    }

    handleChange = (value) => {
        const { name = '' } = this.props;
        this.setState({
            value,
        }, () => {
            // 对姓名[工号]这种类型不做检索
            // 对中心名称-(中心)这种类型不做检索
            // 对于无name的默认类型（如科室），选择后不触发搜索，避免干扰选中显示
            if (value) {
                if (name === 'user') {
                    const index = value.label.indexOf('[');
                    if (index && value.label.endsWith(']')) {
                        this.fetch(value.label.slice(0, index));
                    }
                } else if (name === 'site') {
                    const index = value.label.indexOf('-(');
                    if (index && value.label.endsWith(')')) {
                        this.fetch(value.label.slice(0, index));
                    }
                }
            } else {
                this.fetch('');
            }
            this.props.handleSelect(value);
        });
    }

    render() {
        const { value } = this.state;
        const { style, placeholder, dataSource = [], className = '', disabled = false, filterOption = false } = this.props;
        const options = dataSource.map(d => (
            <Option key={String(d.value)} text={d.text}>
                <Tooltip placement="right" title={d.text}>
                    <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{d.text}</span>
                </Tooltip>
            </Option>
        ));
        return (
            <Select
                mode="combobox"
                allowClear={true}
                labelInValue
                value={value}
                placeholder={placeholder}
                filterOption={filterOption}
                notFoundContent={null}
                onFocus={this.handleFocus}
                onChange={this.handleChange}
                onSearch={this.fetch}
                style={style}
                disabled={disabled}
                className={className}
                optionLabelProp="text"
            >
                {options}
            </Select>
        );
    }
}

export default SearchInput;


// WEBPACK FOOTER //
// ./src/components/common/SearchInput.js